import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductInterface } from '@core/products';
import { UiModule } from '@shared/ui/ui.module';

@Component({
    selector: 'rm-retail-media-products-result',
    standalone: true,
    imports: [CommonModule, UiModule],
    templateUrl: './retail-media-products-result.component.html',
    styleUrls: ['./retail-media-products-result.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetailMediaProductsResultComponent {
    @Input()
    public product!: ProductInterface;

    @Input()
    public isSelected = false;

    @Output()
    public onRemove = new EventEmitter<ProductInterface['id']>();

    @Output()
    public onSelect = new EventEmitter<ProductInterface>();

    protected get formatedShopsCount(): string {
        return this.product.offers.count > 1
            ? `Produkt dostępny w ${this.product.offers.count} sklepach`
            : `Produkt dostępny w ${this.product.offers.count} sklepie`;
    }
}
